import http from './http';

export async function listSemestres(params) {
  const { data } = await http.get('/semestres', { params });
  return data;
}

export async function getSemestre(id) {
  const { data } = await http.get(`/semestres/${id}`);
  return data;
}

export async function createSemestre(payload) {
  const { data } = await http.post('/semestres', payload);
  return data;
}

export async function updateSemestre(id, payload) {
  const { data } = await http.put(`/semestres/${id}`, payload);
  return data;
}

export async function deleteSemestre(id) {
  await http.delete(`/semestres/${id}`);
}

export async function getCurrentSemestre() {
  const { data } = await http.get('/semestres/current');
  return data;
}
